export default __webpack_public_path__ + "static/media/Shadow's Tunic of Engulfing Twilight.8ed3b8f4.jpg";